import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { ConfigurationService } from '../../../../../core/_infrastructure/classes/services/configuration.service';
import { EnumCodigosTwTcAcciones } from '../../../../../_importacion/solicitudes/types/enum';
import { PeriodoCamItemResultsViewModel, PeriodoCamItemViewModel } from '../periodocam.types';

@Component({
    selector: 'app-periodo-list',
    templateUrl: './periodo-list.component.html',
})
export class PeriodoCamListComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() result: PeriodoCamItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() clone = new EventEmitter<number | null>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];
    EnabledCloned = false;

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
        this.configurationService.getValue('PeriodoCam:EnabledCloned').subscribe(result => {
            this.EnabledCloned = JSON.parse(result);
        });
    }

    private initCols(): void {
        const periodoCamVM = proxiedPropertiesOf<PeriodoCamItemViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: periodoCamVM.Id?.toString(), header: 'Id', display: 'none' },
            { field: periodoCamVM.FechaInicio?.toString(), header: 'Fecha Inicio' },
            { field: periodoCamVM.FechaFin?.toString(), header: 'Fecha Fin' },
            { field: periodoCamVM.DescripcionCampania, header: 'Campaña' },
            { field: periodoCamVM.DescripcionPeriodo, header: 'Periodo' },
            { field: periodoCamVM.Parcela?.toString(), header: 'Parcela' },
            { field: periodoCamVM.Confeccion?.toString(), header: 'Confección' },
            { field: periodoCamVM.Invernadero?.toString(), header: 'Invernadero' },
            { field: periodoCamVM.EmpresaDeshidratacion?.toString(), header: 'Empresa Deshid.' },
            { field: periodoCamVM.SuperficieMax?.toString(), header: 'Superficie Máx. (ha)' },
            { field: periodoCamVM.Dextrio?.toString(), header: 'Destrío (%)' },
            { field: periodoCamVM.PresentarSolicitudesFueraPeriodo?.toString(), header: 'Presentar Solicitudes F.P.' },
            { field: periodoCamVM.ControlProduccionExportacion?.toString(), header: 'Control Prod. Ex.' },
            { field: periodoCamVM.HabilitadaTemporalmente?.toString(), header: 'Habilitada Temp.' },
            { field: periodoCamVM.CicloCortoInspParcela?.toString(), header: 'Ciclo Corto Insp. Parcela' },
            { field: periodoCamVM.CicloCortoInspConfeccion?.toString(), header: 'Ciclo Corto Insp. Confección' },
            { field: periodoCamVM.CicloCortoInspInvernadero?.toString(), header: 'Ciclo Corto Insp. Invernadero' },
            { field: periodoCamVM.CicloCortoInspEmpresasDeshidratacion?.toString(), header: 'Ciclo Corto Insp. Emp. Deshidrat.' },
            { field: periodoCamVM.RequiereFirmaInspectorPaisDestino?.toString(), header: 'Requiere Firma Insp. P.D.' },
            { field: periodoCamVM.RequiereAvisoFechaConfeccion?.toString(), header: 'Requiere Aviso Fecha Conf.' },
            { field: periodoCamVM.TamanioMaximoAgrupacion?.toString(), header: 'Tamaño Máx. Agrup.' },
            { field: periodoCamVM.AvisoConfeccion?.toString(), header: 'Aviso Confección' },
            { field: periodoCamVM.AmbitoNacional?.toString(), header: 'Ámbito Nacional' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter.PageNumber * this.result.PageSize;
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (
            !event.rows ||
            event.sortField == 'Link' ||
            event.sortField == 'Parcela' ||
            event.sortField == 'Confeccion' ||
            event.sortField == 'Invernadero' ||
            event.sortField == 'EmpresaDeshidratacion'
        ) {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField || '',
        };

        this.search.emit(f);
    }

    onEdit(item: PeriodoCamItemViewModel): void {
        this.edit.emit(item?.Id);
    }

    onClone(item: PeriodoCamItemViewModel): void {
        this.clone.emit(item?.Id);
    }

    checkClone() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.CLONACION_PERIODO).Visible;
    }

    esPeriodoFinalizado(item: PeriodoCamItemViewModel): boolean {
        const hoy = new Date();
        const fechaFinPeriodo = new Date(item?.FechaFin);
        return hoy >= fechaFinPeriodo;
    }
}
